module.exports = __webpack_public_path__ + "images/digitin.67647e4ce3beb4a3a0d701e36a68b5f7.svg";